import constants from '../constants.js'
import utils from '../utils/utils.js'

const CPL_URL = process.env.REACT_APP_PROXY_URL;

const api = {

    fetch: async (baseurl, uri, query) => {
        const url = CPL_URL + baseurl + uri + (query ?? "");

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json, application/problem+json",
                }
            });

            const body = await response.json();

            if (!response.ok) {
                return {
                    error: true,
                    status: response.status,
                    message: body.message ?? body.detail,
                    title: body.title
                };
            }

            return resolveRefs(body);

        } catch (error) {
            console.error(`Error: ${error}`);
            return {
                error: true,
                status: 500,
                title: "Unexpected Error",
                message: "Something went wrong."
            };
        }
    },

    post: async (baseurl, uri, request) => {
        const url = CPL_URL + baseurl + uri;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json, application/problem+json",
                },
                body: request,
            });

            const body = await response.json();

            if (constants.errorCodes.indexOf(response.status) !== -1) {
                return {
                    error: true,
                    status: response.status,
                    message: body.message ?? body.detail,
                    title: body.title
                };
            }

            return body;
        } catch (error) {
            console.error(`Error: ${error}`);
            return {
                error: true,
                status: 500,
                title: "Unexpected Error",
                message: "Something went wrong."
            };
        }
    },

    put: async (uri, request) => {
        const url = CPL_URL + uri;

        try {
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json, application/problem+json",
                },
                body: request
            });

            const body = await response.json();

            if (!response.ok) {
                return {
                    error: true,
                    status: response.status,
                    message: body.message ?? body.detail,
                    title: body.title
                };
            }

            return body;

        } catch (error) {
            console.error(`Error: ${error}`);
            return {
                error: true,
                status: 500,
                title: "Unexpected Error",
                message: "Something went wrong."
            };
        }
    },

    patch: async (baseurl, uri, request) => {
        const url = CPL_URL + baseurl + uri;

        try {
            const response = await fetch(url, {
                method: 'PATCH',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json, application/problem+json",
                },
                body: request,
            });

            const body = await response.json();

            if (constants.errorCodes.indexOf(response.status) !== -1) {
                return {
                    error: true,
                    status: response.status,
                    message: body.message ?? body.detail,
                    title: body.title
                };
            }

            return body;
        } catch (error) {
            console.error(`Error: ${error}`);
            return {
                error: true,
                status: 500,
                title: "Unexpected Error",
                message: "Something went wrong."
            };
        }
    },
}

function resolveRefs(obj, root = obj, map = {}) {
    if (obj && typeof obj === 'object') {
        if (obj.$ref) return map[obj.$ref];
        if (obj.$id) map[obj.$id] = obj;
        for (const key in obj) obj[key] = resolveRefs(obj[key], root, map);
    }
    return obj;
}



export default api; 
